// extracted by mini-css-extract-plugin
export default {"ged":"ged_ged__3WbLH","desktop":"ged_desktop__CE5Gg","card":"ged_card__YHFi9","count":"ged_count__FOOlr"};